<template>
  <b-form @submit.prevent="insertBridgeInfo">
    <b-card class="border0" body-class="grpHd anal">
      <b-row>
        <b-col class="col-6">
          <label class="head">{{ rdTitle }}</label>
          <b-form-input v-model="rd"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">{{ tlTitle }}</label>
          <b-form-input v-model="tl"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">{{ rdMmTitle }}</label>
          <b-form-input v-model="rdMm"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">{{ srFTitle }}</label>
          <b-form-input v-model="srF"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">{{ rmfTitle }}</label>
          <b-form-input v-model="rmf"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">{{ srDTitle }}</label>
          <b-form-input v-model="srD"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">{{ rmfMmTitle }}</label>
          <b-form-input v-model="rmfMm"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">{{ kdTitle }}</label>
          <b-form-input v-model="kd"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">{{ srTitle }}</label>
          <b-form-input v-model="sr"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">{{ rfTitle }}</label>
          <b-form-input v-model="rf"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">{{ filterLTitle }}</label>
          <b-form-input v-model="filterL"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">{{ ipreTitle }}</label>
          <b-form-input v-model="ipre"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">{{ filterHTitle }}</label>
          <b-form-input v-model="filterH"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">{{ slTitle }}</label>
          <b-form-input v-model="sl"></b-form-input>
        </b-col>
      </b-row>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="empty-searchBtn" @click="refreshData"
          ><i class="fa fa-search"></i>조회</b-button
        >
        <b-button class="empty-modBtn" type="submit"
          ><i class="fa fa-edit"></i>변경</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["getUserId", "getAlertOptions", "getConfirmOptions"]),
  },
  props: {
    stid: {
      type: String,
      required: true,
    },
    bridgeData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rd: null,
      rdMm: null,
      rmf: null,
      rmfMm: null,
      sr: null,
      filterL: null,
      filterH: null,
      tl: null,
      srF: null,
      srD: null,
      kd: null,
      rf: null,
      ipre: null,
      sl: null,
      rdTitle: "기준 감쇠비",
      rdMmTitle: "추정  감쇠비 허용 오차(%)",
      rmfTitle: "기준 고유진동수 (Hz)",
      rmfMmTitle: "추정 고유진동수 허용 오차(%)",
      srTitle: "센서 데이터 획득 샘플링율(Hz)",
      filterLTitle: "BPF의 Low cut 주파수(Hz)",
      filterHTitle: "BPF의 High cut 주파수(Hz)",
      tlTitle: "데이터 분석 구간(sec)",
      srFTitle: "자유진동구간(%)",
      srDTitle: "감쇠구간(%)",
      kdTitle: "정적응답계수",
      rfTitle: "이전 내하력",
      ipreTitle: "이전 충격계수",
      slTitle: "교량 경간 길이(m)",
    };
  },
  created() {
    this.rd = this.bridgeData.rd;
    this.rdMm = this.bridgeData.rdMm;
    this.rmf = this.bridgeData.rmf;
    this.rmfMm = this.bridgeData.rmfMm;
    this.sr = this.bridgeData.sr;
    this.filterL = this.bridgeData.filterL;
    this.filterH = this.bridgeData.filterH;
    this.tl = this.bridgeData.tl;
    this.srF = this.bridgeData.srF;
    this.srD = this.bridgeData.srD;
    this.kd = this.bridgeData.kd;
    this.rf = this.bridgeData.rf;
    this.ipre = this.bridgeData.ipre;
    this.sl = this.bridgeData.sl;
  },
  beforeMount() {},
  mounted() {},
  destroyed() {},
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    insertBridgeInfo() {
      if (!this.isNumeric(this.rd)) {
        this.showNumericErrorMessage(this.rdTitle);
        return;
      }
      if (!this.isNumeric(this.rdMm)) {
        this.showNumericErrorMessage(this.rdMmTitle);
        return;
      }
      if (!this.isNumeric(this.rmf)) {
        this.showNumericErrorMessage(this.rmfTitle);
        return;
      }
      if (!this.isNumeric(this.rmfMm)) {
        this.showNumericErrorMessage(this.rmfMmTitle);
        return;
      }
      if (!this.isNumeric(this.sr)) {
        this.showNumericErrorMessage(this.srTitle);
        return;
      }
      if (!this.isNumeric(this.filterL)) {
        this.showNumericErrorMessage(this.filterLTitle);
        return;
      }
      if (!this.isNumeric(this.filterH)) {
        this.showNumericErrorMessage(this.filterHTitle);
        return;
      }
      if (!this.isNumeric(this.tl)) {
        this.showNumericErrorMessage(this.tlTitle);
        return;
      }
      if (!this.isNumeric(this.srF)) {
        this.showNumericErrorMessage(this.srFTitle);
        return;
      }
      if (!this.isNumeric(this.srD)) {
        this.showNumericErrorMessage(this.srDTitle);
        return;
      }
      if (!this.isNumeric(this.kd)) {
        this.showNumericErrorMessage(this.kdTitle);
        return;
      }
      if (!this.isNumeric(this.rf)) {
        this.showNumericErrorMessage(this.rfTitle);
        return;
      }
      if (!this.isNumeric(this.ipre)) {
        this.showNumericErrorMessage(this.ipreTitle);
        return;
      }
      if (!this.isNumeric(this.sl)) {
        this.showNumericErrorMessage(this.slTitle);
        return;
      }
      var reqBody = {
        stid: this.stid,
        rd: this.rd,
        rdMm: this.rdMm,
        rmf: this.rmf,
        rmfMm: this.rmfMm,
        sr: this.sr,
        filterL: this.filterL,
        filterH: this.filterH,
        tl: this.tl,
        srF: this.srF,
        srD: this.srD,
        kd: this.kd,
        rf: this.rf,
        ipre: this.ipre,
        sl: this.sl,
      };
      this.$http
        .post("/loadCarryingCapacityAnalysis/updateBridgeInfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.setAlertTitle("변경 완료");
            this.$bvModal
              .msgBoxOk("교량 정보가 변경되었습니다.", this.getAlertOptions)
              .then((value) => {
                this.$emit("setBridgeInfo");
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    refreshData() {
      this.rd = this.bridgeData.rd;
      this.rdMm = this.bridgeData.rdMm;
      this.rmf = this.bridgeData.rmf;
      this.rmfMm = this.bridgeData.rmfMm;
      this.sr = this.bridgeData.sr;
      this.filterL = this.bridgeData.filterL;
      this.filterH = this.bridgeData.filterH;
      this.tl = this.bridgeData.tl;
      this.srF = this.bridgeData.srF;
      this.srD = this.bridgeData.srD;
      this.kd = this.bridgeData.kd;
      this.rf = this.bridgeData.rf;
      this.ipre = this.bridgeData.ipre;
      this.sl = this.bridgeData.sl;
    },
    isNumeric(num) {
      num = String(num).replace(/^\s+|\s+$/g, "");
      var regex =
        /^[+\\-]?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+){1}(\.[0-9]+)?$/g;
      if (regex.test(num)) {
        num = num.replace(/,/g, "");
        if (isNaN(num)) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    showNumericErrorMessage(title) {
      this.setAlertTitle();
      this.$bvModal
        .msgBoxOk(title + " 값을 확인해주세요.", this.getAlertOptions)
        .then((value) => {})
        .catch((err) => {
          console.error(err);
        });
    },
    closeModal() {
      this.$bvModal.hide("loadCarryingCapacityAnalysisModal");
    },
  },
};
</script>

<style lang="scss">
#loadCarryingCapacityAnalysisModal .modal-dialog {
  max-width: 950px;
  & .modal-content {
    & .card {
      padding: 0 30px 30px;
      & .card-body {
        border: 1px solid #7367f0;
        border-radius: 8px;
        & .row .col {
          & label {
            display: flex;
            align-items: center;
            height: 100%;
            padding-bottom: 1px;
            width: auto;
            margin: 0 15px;
            &.head {
              width: 210px;
              margin: 0 10px 0 0;
            }
          }
          & input,
          & select {
            width: 170px;
          }
        }
        &.grpHd {
          &::before {
            display: block;
            position: absolute;
            top: -15px;
            left: 50px;
            font-size: 16px;
            font-weight: 600;
            border: 1px solid #7367f0;
            border-radius: 10px;
            color: #b4b7bd;
            background: #283046;
            padding: 1px 10px 3px;
            letter-spacing: 1px;
          }
        }
      }
      &:first-child {
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/LoadCarryingCapacityAnalysisModal.vue